import * as ng from 'angular';

const FilterModule = ng.module('filters', ['services']);
export { FilterModule };
